export const ColorColumns = [
  "ItemNo",
  "CRMColorName",
  "POColorName",
]